class CustomEventService {
	static get CUSTOM_TRACKING_EVENT() {
		return 'CUSTOM_TRACKING_EVENT';
	}
}

export { CustomEventService };
